import type React from "react";
import {Outlet, useParams} from "react-router";
import {Box} from "@mui/system";
import {SimpleEnvWrapper} from "../../jobs/wrapper/SimpleEnvWrapper";
import type {Supplier360RouteMatch} from "~/routing/catRoutes";

/** Databag-loading wrapper for the whole Supplier 360 module (registry + detail). */
export const Supplier360Layout: React.FC = () => {
    const {supplierId} = useParams<Supplier360RouteMatch>();

    return (
        <SimpleEnvWrapper state={{fluid: true, appSection: 'supplier-360'}}>
            <Box sx={supplierId ? {position: 'relative'} : {p: 2, height: 'calc(100vh - 64px)'}}>
                <Outlet/>
            </Box>
        </SimpleEnvWrapper>
    );
};
